// Existing Profile field vocabulary shared by the support-profile resolver,
// Profile placement contract, and Knowledge persistence. Keep storage-facing
// validation here so those three boundaries cannot silently drift apart.
export const PROFILE_ARRAY_FIELDS = Object.freeze([
  'earlyWarningSigns',
  'thingsThatUsuallyHelp',
  'thingsToAvoid',
  'safetyConsiderations',
  'communicationStyle',
  'familySupportTips',
  'whatHelps',
  'whatCanBeDifficult',
]);

export const PROFILE_TEXT_FIELDS = Object.freeze([
  'about',
  'communicationNotes',
  'schoolTherapySuggestions',
]);

export const PROFILE_FIELDS = Object.freeze([
  ...PROFILE_ARRAY_FIELDS,
  ...PROFILE_TEXT_FIELDS,
]);

const PROFILE_FIELD_SET = new Set(PROFILE_FIELDS);

export const isProfileField = (value = '') => PROFILE_FIELD_SET.has(String(value || '').trim());
